import { createFileRoute, Outlet } from "@tanstack/react-router";
import { Box, Loader } from "@saviynt/design-system";
import { ErrorState } from "@repo/ui";
import { useIntl } from "react-intl";
import { useGetCurrentUserRoles } from "../shell-components/hooks/useGetCurrentUserRoles";
import AccessDenied from "../components/AccessDenied";
import { ROLES } from "../constants/roles";

function AdminLayout() {
  const intl = useIntl();
  const { data, isLoading, isError } = useGetCurrentUserRoles();
  const isAdmin = data?.roles?.includes(ROLES.ISPM_ADMIN) ?? false;

  if (isLoading) {
    return (
      <Box className="w-full min-h-[calc(100vh-80px)] flex justify-center items-center">
        <Loader kind="loop" format="main" size="medium" color="brand" />
      </Box>
    );
  }

  if (isError) {
    return (
      <Box
        className="w-full min-h-[calc(100vh-80px)] flex justify-center items-center"
        dataTestId="AdminErrorState"
      >
        <ErrorState
          message={intl.formatMessage({
            id: "sb1r0g",
            defaultMessage: "Failed to verify permissions. Please try again.",
            description:
              "Error message when role verification fails in admin layout",
          })}
        />
      </Box>
    );
  }

  if (!isAdmin) {
    return <AccessDenied />;
  }

  return <Outlet />;
}

export const Route = createFileRoute("/admin")({
  component: AdminLayout,
});
